module.exports = __webpack_public_path__ + "img/ro_status.875783d7.svg";